<template>
    <div id="dealer-page">
        <section-definition
            :title="page.title"
            :menuItems="menuItems"
            :refresh_fn="get_organizations"
        >
        </section-definition>

        <my-show-error
                v-model="dialog_show_error"
                :error="show_error_obj"
        ></my-show-error>

        <!---------------------------------add new group--------------------------------------------------------------->
        <v-dialog v-model="dialog" persistent max-width="700px" attach="#dealer-page" >
            <!--<template v-slot:activator="{ on }">-->
                <!--<v-btn color="accent" dark class="mb-2" v-on="on">Add Group</v-btn>-->
            <!--</template>-->
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form">
                        <v-container fluid grid-list-md page>
                            <v-layout wrap>

                                <v-flex xs12 sm12 md12 v-if="!agency_disabled">
                                    <v-autocomplete
                                            :items="agencies"
                                            label="Agency"
                                            v-model="editedItem.agency_id"
                                            item-value="_id"
                                            item-text="name"
                                            required
                                            :disabled="agency_disabled"
                                    ></v-autocomplete>
                                </v-flex>

                                <v-flex xs12 sm6 md8>
                                    <v-text-field
                                            v-model="editedItem.name"
                                            label="Dealer Group Name*"
                                            :rules="[x => isRequired(x, 'Name')]"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-autocomplete
                                            :items="[{text:'Yes', value:true}, {text:'No', value:false}]"
                                            label="Account Active?"
                                            v-model="editedItem.is_active"
                                            item-value="value"
                                            item-text="text"
                                            required
                                    ></v-autocomplete>
                                </v-flex>


                                <!--<v-flex xs12 sm12 md12>-->
                                    <!--<v-text-field v-model="editedItem.address_street1" label="Street 1"></v-text-field>-->
                                <!--</v-flex>-->
                                <!--<v-flex xs12 sm12 md12>-->
                                    <!--<v-text-field v-model="editedItem.address_street2" label="Street 2"></v-text-field>-->
                                <!--</v-flex>-->
                                <v-flex xs12 sm12 md4>
                                    <v-text-field v-model="editedItem.address_city" label="City"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <!--<v-text-field v-model="editedItem.address_state" label="State"></v-text-field>-->
                                    <v-autocomplete
                                            label="State"
                                            :items="states"
                                            item-value="abbr"
                                            item-text="txt"
                                            v-model="editedItem.address_state"
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field v-model="editedItem.address_zip" label="Zip"></v-text-field>
                                </v-flex>


                                <v-flex xs12 sm6 md4>
                                    <v-autocomplete
                                            label="Level 1 Curriculum"
                                            :items="curricula"
                                            item-value="_id"
                                            item-text="name"
                                            v-model="editedItem.curricula.level_1"
                                            :rules="[x => isRequired2(x, 'Curriculum',{nullOk: true} )]"
                                            required
                                    ></v-autocomplete>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <v-autocomplete
                                            label="Level 2 Curriculum"
                                            :items="curricula"
                                            item-value="_id"
                                            item-text="name"
                                            v-model="editedItem.curricula.level_2"
                                            :rules="[x => isRequired2(x, 'Curriculum', {nullOk: true})]"
                                            required
                                    ></v-autocomplete>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <v-autocomplete
                                            label="Level 3 Curriculum"
                                            :items="curricula"
                                            item-value="_id"
                                            item-text="name"
                                            v-model="editedItem.curricula.level_3"
                                            :rules="[x => isRequired2(x, 'Curriculum', {nullOk: true})]"
                                            required
                                    ></v-autocomplete>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <v-autocomplete
                                            label="Level 4 Curriculum"
                                            :items="curricula"
                                            item-value="_id"
                                            item-text="name"
                                            v-model="editedItem.curricula.level_4"
                                            :rules="[x => isRequired2(x, 'Curriculum',{nullOk: true})]"
                                            required
                                    ></v-autocomplete>
                                </v-flex>


                                <v-flex xs12 sm12 md12 >
                                    <v-textarea
                                            label="Comments"
                                            v-model="editedItem.comments"
                                            outline
                                            auto-grow
                                    >
                                    </v-textarea>
                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>

                <v-layout row v-if="form_error">
                    <!--<v-flex grow></v-flex>-->
                    <v-spacer></v-spacer>
                    <v-flex shrink class="pr-3 red--text"> {{form_error}}</v-flex>
                </v-layout>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="accent" @click="close">Cancel</v-btn>
                    <v-btn color="accent" @click="save" :disabled="form_valid">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>






        <!---------------------------------table showing groups-------------------------------------------------------->
        <v-container fluid grid-list-xl page>
            <v-card-title  >
                <v-btn color="accent" dark class="mb-2" @click="dialog=true">Add Group</v-btn>

                <v-switch
                        v-model="showOnlyActive"
                        :label="'Show only Active Accounts'"
                        color="accent"
                        v-on:change="update_orgs"
                ></v-switch>

                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search_txt"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>


            </v-card-title>



            <v-data-table
                    :headers="headers"
                    :items="dealer_groups"
                    :search="search_txt"
                    :rows-per-page-items="pagination"
                    class="elevation-1 border-radius6"
                    :loading="data_loading"
            >
                <template slot="items" slot-scope="props">

                    <tr v-bind:class="get_row_class(props.item.is_active)"
                        class="row"
                        @click="editItem(props.item)"
                        :key="props.item._id"
                    >
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.address_city }}</td>
                        <td>{{ props.item.address_state }}</td>
                        <td>{{ props.item.is_active ? 'Yes' : 'No' }}</td>
                        <td>{{ props.item.comments}}</td>
                        <!--<td class="justify-center">-->
                            <!--<v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>-->
                            <!--&lt;!&ndash;<v-icon small @click="deleteItem(props.item)"> delete </v-icon>&ndash;&gt;-->
                        <!--</td>-->
                    </tr>
                </template>
                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search_txt }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>

        </v-container>

    </div>
</template>


<style scoped>
    .row_inactive {
        color: #b8b8b8;
    }
    .error_txt{
        color: red;
    }

    .row{
        cursor: pointer;
    }
</style>


<script>
   import axios from 'axios';

   import states_data from '../data/states.js';
   import validate from '../mixins/validation'
   import data_getters from '../mixins/data_getters'


   export default {
      mixins: [data_getters, validate],
      data() {
         return {
            //data for dealers list
            headers: [
               // {text: 'ID', value: 'dealer_num'},
               {text: 'Group Name', value: 'name'},
               {text: 'City', value: 'address_city'},
               {text: 'State', value: 'address_state'},
               {text: 'Active', value: 'is_active'},
               {text: 'Comments', value:"comments" },
               // {text: 'Edit', value:"" },
            ],

            dealer_groups: [],
            // pagination: [25, 50, 100, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
            pagination: [25, 50, 100, {"text": "All","value":-1}],
            showOnlyActive: true,

            data_loading: false,

            curricula: [],
            curricula_all: [],
            curricula_active: [],
            agencies:[{name:''}],

            states: states_data,
            form_error: null,


            //search bar
            search_txt: '',

            //add new/edit dialog
            formTitle: 'Add New Dealer Group',
            dialog: false,
            editedIndex: -1,
            editedItem: {
               name: '',
               agency_id: '',
               address_street1: '',
               address_street2: '',
               address_city: '',
               address_state: '',
               address_zip: '',
               is_active: true,
               curricula: {},

            },

            editedItemDefault: { // this item should never be changed
               name: '',
               agency_id: '',
               address_street1: '',
               address_street2: '',
               address_city: '',
               address_state: '',
               address_zip: '',
               is_active: true,
               curricula: {},
               comments: '',
            },

            //main page header
            page: {
               title: "Manage Dealership Groups",
               headline: "Black Page",
            },
            menuItems: [
               {title: "Only Show Active Accounts", value: true}
            ]
         };
      },

      methods:{
         //*************************************************************************************************************



         async update_orgs(){
            this.data_loading = true;
            this.dealer_groups = await this.get_organizations({is_active: this.showOnlyActive});
            this.data_loading = false;
         },

         //*************************************************************************************************************
         close () {
            this.dialog = false;
            setTimeout(() => {
               this.editedItem = Object.assign({}, this.editedItemDefault);
               this.editedIndex = -1;
               this.formTitle = 'Add New Dealer Group';
               this.$refs.form.resetValidation();
               this.form_error = null;
               this.curricula = this.curricula_active;
            }, 300)
         },

         //*************************************************************************************************************
         async save () {

            if (this.$refs.form.validate()){

               if (this.$auth.profile.user_role !== 'SuperAdmin'){
                  this.editedItem.agency_id = this.$auth.profile.agency_id;
               }

               let post_data = JSON.parse(JSON.stringify(this.editedItem));
               if (post_data.is_active.value !== undefined){
                  post_data.is_active = post_data.is_active.value;
               }

               delete post_data.updatedAt;
               delete post_data.createdAt;
               delete post_data.__v;

               console.log(post_data)

               //save to db
               try {
                  // console.log(post_data);
                  let token = await this.$auth.getAxiosHeader();
                  let url = this.$baseUrlApi + '/updateOrganization';
                  await axios.post(url, post_data, token);

                  // refresh data from db
                  this.update_orgs();
                  this.close();
               }
               catch(err){
                  this.form_error = this.show_error_details(err, 'save()');
                  // this.form_error= 'There was an error saving.  Please see console for details.';

               }
            }
            else{
               this.form_error = 'Please check highlighted fields'

            }


         },

         //*************************************************************************************************************
         editItem (item) {
            this.curricula = this.curricula_all;
            this.formTitle = 'Edit Dealer Group';
            this.editedIndex = this.dealer_groups.indexOf(item);
            this.editedItem = Object.assign({}, item);


            this.dialog = true
         },

         //*************************************************************************************************************
         deleteItem (item) {
            const index = this.dealers.indexOf(item);
            confirm('Are you sure you want to delete this item?') && this.dealers.splice(index, 1)
         },
      },

      computed:{
        form_valid(){
           if (this.$refs.form)
            return !this.$refs.form.validate();
           else
              return false;
        },
         agency_disabled(){
            if (this.$auth.profile.user_role === 'SuperAdmin'){
               return false;
            }
            else{
               return true;
            }
         }


      },

      created(){
         // this.agencies = await this.get_agencies();
         // this.dealer_groups = await this.get_organizations();
         // this.curricula = await this.get_curricula();

         this.data_loading = true;
         this.get_organizations({enrich_curricula: false}).then(data =>{
            this.dealer_groups = data;
            this.data_loading = false;
         });

         this.get_agencies().then(data =>{
            this.agencies = data;
         });

         this.get_curricula().then(data =>{
            for (let i=0; i<data.length; i++){

               if (!data[i].is_active){
                  data[i].name = data[i].name + " (inactive)"
               }
            }
            data.unshift({_id: null, name: 'None'});
            this.curricula_all = data;
         });

         this.get_curricula({is_active:true}).then(data =>{
            data.unshift({_id: null, name: 'None'});
            this.curricula_active = data;
            this.curricula = this.curricula_active;
         });

      }



   };
</script>
